import { useEffect,useState } from "react";
import FullPageLoader from '@src/common/FullPageLoader';
import { useLanguage } from "../../src/context/LanguageContext";
import ReactSelect from "react-select";
import { useParams } from "react-router-dom";
import {assignLead} from '../../src/store/slices/remittance';
import {LEAD_REMITTANCE_STATUS_MARK,LEAD_ASSIGN_TO} from '../config/constant';

const ConfirmPopup = (props: any) => {
    const { id } = useParams<{ id: string }>()
    const {translations} = useLanguage();
    const {from,LeadAssignTo,remittanceType,selectedLeads,statusMark,setConfirmationMessage,setLeadAssignTo} = props;
    let {show} = props;
    const [formData, setFormData] = useState<any>({});
    const [formErrors, setFormErrors] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [remittanceStatus, setRemittanceStatus] = useState<number>(0);
    useEffect(()=>{
        if(show) document.body.classList.add("overflow-hidden");
        return ()=>{
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])

    useEffect(()=>{
       if(statusMark && statusMark.length > 0){
            setRemittanceStatus(+statusMark[0].value);
       }
    }, [statusMark])

    const handleChange = (selectedValue: any, key: string) => {
        let value: any;
        value = selectedValue.target.value;
        setFormData((prev: any) => ({
            ...prev,
            [key]: value,
        }));
        if(key === "remarks" && from === 'InsurerPartnerRemittance'){
            props.setLeadRemark(value);
        }
        setFormErrors((prev: any) => {
            const updatedErrors = { ...prev };
            delete updatedErrors[key];
            return updatedErrors;
        });
    }

    // Validate form data
    const validateForm = (): boolean => {
        let errors: any = {};
        if(from === 'SendToMaker'){     
            //TC ID (Required)
            // if (!formData.remarks) {
            //     errors.remarks = "Remark is required.";
            // }
        }
        setFormErrors(errors);
        // return true if no errors
        return Object.keys(errors).length === 0;
    };

    const handlePopup = async () => {
        const isFormValid = validateForm();
        if(isFormValid){
            try{
                setLoading(true);
                let payload:any = {
                    lead_id : id,
                    lead_assign_to : LeadAssignTo,
                    remittance_type : remittanceType,
                    remarks:formData.remarks
                }
                if(selectedLeads && selectedLeads.length > 0){
                    payload.bulk_update_leads = selectedLeads.map(({ remittance_status,remittance_type_id, ...rest }:any) => rest);
                    payload.is_bulk_update = 1;
                    delete payload.remittance_type;
                    delete payload.lead_id;
                }
                if (remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['COMPLETE']){
                    payload.mark_payment_complete= true
                }
                const response:any = await assignLead(payload);
                if (response?.status === 200) {
                    setFormData({});
                    setFormErrors({});
                    props.reloadDetail();
                    props.confirmNo();
                }
            }catch (error) {
                console.error("Error while save Remittance Payment:", error);
            }finally {
                setLoading(false);
            }
        }
    }

    const handleStatusChange = (value: number) => {
        if (value === LEAD_REMITTANCE_STATUS_MARK['MAKE_PAYMENT'] && props.onMakePaymentSelect) {
            props.confirmNo();
            props.onMakePaymentSelect();
            return;
        } else if (value === LEAD_REMITTANCE_STATUS_MARK['BACK_TO_OPS']) {
            setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"])
            setLeadAssignTo(LEAD_ASSIGN_TO['REM_OPS']);
        } else if(value === LEAD_REMITTANCE_STATUS_MARK['BACK_TO_MAKER']){
            setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"])
            setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
        }else if (value === LEAD_REMITTANCE_STATUS_MARK['COMPLETE']){
            setConfirmationMessage(translations.Remittance?.["COMPLETE_PAYMENT_CONFIRMATION"])
            setLeadAssignTo("");
        }
        setRemittanceStatus(value);
    }

    return (
        <div className="mark-lost-popup deleteConfirmation">
            <FullPageLoader show={loading} />
            <div className="modal display-block" role="dialog">
                <section className="modal-main" role="document">
                    <div className="modal-header">
                        {
                        !props.isConfirmNotVisible &&
                            <h2 className="modal-title">{props.title || translations.commonMsg?.['Confirm'] || translations.commonMsg?.loading}</h2>
                        }
                        <button type="button" className="close_icn" data-dismiss="modal" aria-label="Close" onClick={() => {
                            props.confirmNo();
                        }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <h3>{props.message || "Are you sure to want to delete?"}</h3><br></br>
                    </div>
                    
                    {
                        props.isReasonVisible && 
                        <div>
                        <ReactSelect
                            options={props.reasonList}
                            onChange={(e: any) => props.handleChange(e.value)}
                            value={props.reasonList.find((x: any) => x.value === props.selectedReason)}
                            placeholder={props.placeholder || ""}
                        />
                        <br></br>
                        </div>
                    }
                    {
                        from === 'SendToMaker' &&
                        <>
                         {
                            statusMark && statusMark.length > 0 &&
                            <div>
                                <ReactSelect
                                    options={statusMark}
                                    onChange={(e: any) => handleStatusChange(e.value)}
                                    value={statusMark.find((x: any) => x.value === remittanceStatus)}
                                    placeholder="Remittance Status"
                                />
                            <br></br>
                            </div>
                            }
                            <fieldset className="remarksTxt">
                                <div className="material">
                                    <textarea id="comments" rows={8} placeholder=" " name="comments" className="form-input textarea-height" value={formData.remarks || ""} onChange={(e) => handleChange(e, "remarks")}/>
                                    <label data-label='Remarks' className="form-label"></label>
                                </div>
                                {formErrors.remarks && (
                                    <small className="error">{formErrors.remarks}</small>
                                )}
                            </fieldset>                        
                        </>
                    }
                    {
                        from === 'InsurerPartnerRemittance' &&
                        <fieldset className="">
                            <div className="material">
                                <textarea id="comments" rows={8} placeholder=" " name="comments" className="form-input textarea-height" value={formData.remarks || ""} onChange={(e) => handleChange(e, "remarks")}/>
                                <label data-label='Remarks' className="form-label"></label>
                            </div>
                            {formErrors.remarks && (
                                <small className="error">{formErrors.remarks}</small>
                            )}
                        </fieldset>   
                    }
                    
                    
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary btn-lg m-sm-r" onClick={() => {
                            if (from === 'SendToMaker') {
                                handlePopup();
                            } else {
                                props.confirmYes();
                            }
                        }}>{(from === 'EmiComponent' || from === 'CONFIRM_PAYMENT' )? 'Yes, Continue': (translations.commonMsg?.['Yes'] || translations.commonMsg?.loading)}</button>

                        { from !== 'EmiComponent' && <button type="button" className="btn btn-line" onClick={() => {
                            props.confirmNo(); 
                        }}>{from === 'CONFIRM_PAYMENT' ? translations.commonMsg?.['NO_GO_BACK'] || translations.commonMsg?.loading : translations.commonMsg?.['No'] || translations.commonMsg?.loading}</button>
                        }
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ConfirmPopup;